export default __webpack_public_path__ + "static/media/burger-menu.23e95ad9.svg";